// extracted by mini-css-extract-plugin
export default {"verticalDivider":"tfu2Zg03"};